import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountCompaniesQueryKey } from "../account.keys";

export const useAdminFetchAccountCompanies = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, isFetched, isFetching, refetch } = useQuery({
		queryKey: accountCompaniesQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.Admin.SuretyAccount.Get.Response.Company[]>(
				`/v2/admin/surety/accounts/${accountId}/companies`,
			),
		retry: false,
	});

	return {
		companies: data,
		companiesError: error,
		companiesIsLoading: isLoading,
		companiesIsFetched: isFetched,
		companiesIsFetching: isFetching,
		refetchCompanies: refetch,
	};
};
